/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { memo, useMemo } from 'react';

import AutoAwesome from '@mui/icons-material/AutoAwesome';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { getCommandIntelligenceAccessDeniedStyles } from './CommandIntelligenceAccessDenied.styles';

const CommandIntelligenceAccessDenied = ({ message }) => {
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const styles = useMemo(() => getCommandIntelligenceAccessDeniedStyles(theme, isMobile), [theme, isMobile]);

  const displayMessage =
    typeof message === 'string' && message.trim() !== ''
      ? message
      : intl.formatMessage({ id: 'command_intelligence_error_missing_invoke_permission' });

  return (
    <Box sx={styles.root} role="alert">
      <Box sx={styles.content}>
        <Box sx={styles.iconWrap}>
          <AutoAwesome sx={styles.icon} aria-hidden />
        </Box>

        <Typography component="h3" variant="subtitle1" sx={styles.title}>
          {intl.formatMessage({ id: 'command_intelligence_access_denied_title' })}
        </Typography>

        <Typography variant="body2" sx={styles.message}>
          {displayMessage}
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(CommandIntelligenceAccessDenied);
